import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  IEventDirectoryState,
  IEventDirectoryPopulated,
  IEventDirectory,
} from "../types";

export const initialState: IEventDirectoryState = {
  current: null,
  company: [],
};

const eventDirectorySlice = createSlice({
  initialState,
  name: "eventDirectory",
  reducers: {
    // current
    loadCurrentDirectory: (
      state,
      action: PayloadAction<IEventDirectoryPopulated>,
    ) => ({ ...state, current: action.payload }),
    resetCurrentDirectory: (state) => ({ ...state, current: null }),
    setCurrentDirectoryName: (state, action: PayloadAction<string>) =>
      state.current
        ? { ...state, current: { ...state.current, name: action.payload } }
        : state,
    // company
    loadCompanyDirectories: (
      state,
      action: PayloadAction<IEventDirectory[]>,
    ) => ({ ...state, company: action.payload }),
  },
});

export const {
  resetCurrentDirectory,
  loadCurrentDirectory,
  loadCompanyDirectories,
  setCurrentDirectoryName,
} = eventDirectorySlice.actions;

export default eventDirectorySlice.reducer;
